// extracted by mini-css-extract-plugin
export var backgroundImage = "HeroSectionWithImageRight-module--backgroundImage--5ea4f";
export var columnWrapper = "HeroSectionWithImageRight-module--columnWrapper--177a8";
export var logo = "HeroSectionWithImageRight-module--logo--c97f0";
export var wrapper = "HeroSectionWithImageRight-module--wrapper--808cc";